exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".denom-icon-wrapper {\n  position: relative;\n  display: inline-block;\n  cursor: pointer; }\n\n.denom-icon-sm {\n  width: 35px;\n  height: auto; }\n\n.denom-icon-popover-window {\n  z-index: 99999 !important;\n  pointer-events: none; }\n  .denom-icon-popover-window .popover-content {\n    padding: 8px;\n    background: #fff;\n    border-radius: 10px;\n    text-align: center; }\n  .denom-icon-popover-window.popover {\n    border-radius: 10px;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n    border: 1px solid #ddd; }\n\n.denom-icon-lg {\n  width: 80px;\n  height: auto;\n  display: block;\n  margin: 0 auto; }\n\n.denom-icon-label {\n  font-size: 12px;\n  font-weight: bold;\n  color: #333;\n  margin-top: 4px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/denom-icon/denom-icon.scss
// module id = 941
// module chunks = 1